export default {
  'call-dispatcher': 'Позвонить диспетчеру',
  'error-code': 'Ошибка {code}',
  'dispatcher-hint': 'Если вы видите эту ошибку, свяжитесь с диспетчером Rx2Go',
  400: {
    title: 'Неверный запрос',
    description: 'Похоже, в ссылке, по которой вы перешли, есть небольшая ошибка, и мы не смогли обработать запрос.',
  },
  404: {
    title: 'Страница не найдена',
    description: 'Страница, которую вы ищете, могла быть удалена, переименована или временно недоступна.',
  },
  500: {
    title: 'Внутренняя ошибка сервера',
    description: 'Произошла непредвиденная ошибка. Пожалуйста, попробуйте позже.',
  },
  generic: {
    title: 'Что-то пошло не так',
    description: 'Что-то пошло не так',
  },
}
